import React, { Component } from 'react';
import * as logger from 'universal-logger';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';

export const withSagas = config => WrappedComponent => {
  class DecoratedComponent extends Component {
    constructor(...args) {
      super(...args);
      // Watch sagas should be initialized before we call on load
      this.runSagas(config.watch, { dedupe: true });
      this.runSagas(config.load);
    }

    componentWillUnmount() {
      this.runSagas(config.cleanup);
    }

    runSagas(sagas, { dedupe = false } = {}) {
      if (!sagas) {
        return;
      }

      const {
        props,
        context: { store, client },
      } = this;

      const sagaRunner = dedupe ? store.runSaga : store.runSagaOnce;

      []
        .concat(sagas)
        .filter(this.validateSaga)
        .forEach(saga => sagaRunner(saga, client, props));
    }

    validateSaga(saga) {
      const isValid = typeof saga === 'function';

      if (!isValid) {
        const displayName = WrappedComponent.displayName || WrappedComponent.name || WrappedComponent;
        logger.warn(`Invalid saga found in ${displayName}`, saga);
      }

      return isValid;
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  DecoratedComponent.displayName = `withSagas(${WrappedComponent.displayName || WrappedComponent.name})`;
  DecoratedComponent.contextTypes = {
    client: PropTypes.object,
    store: PropTypes.object,
  };
  DecoratedComponent.withSagas = config;

  return hoistStatics(DecoratedComponent, WrappedComponent);
};
